const colorChoices = {
    "V": "white",
    "Iinj": "#ff6e27",
    "Ina": "#7700a6",
    "Ik": "#00b3fe",
    "Il": "#0016ee",
    "Ic": "#65dc98",
    "Ir": "#8386f5",
    "Gna": "#65dc98",
    "Gk": "#0a9cf5",
    "m": "#ff124f",
    "n": "#7a04eb",
    "h": "#fe75fe",
    "m3h": "#ff00a0",
    "n4": "#bf40bf",
    "simulation_time": "#00b3fe",
    "stimulus_duration": "#65dc98",
    "plot_background": "#000000"
}

export default colorChoices;

